import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { AuthenticationState } from "./type";


const noSession = {
    status: AuthenticationState.Opening,
    apiUser: {
        id: -1,
        login: "anonymous",
        nom: "anonymous",
        token: null,
    },
};

const state = {
    session: noSession,
    noSession: noSession,
    dateRange: [-1, 5],
    localDBStatus: "empty",
    isLocalDBComplete:false,
    storeWillUpdate:false,
    memDBStatus: "empty",
    memDBStats: {},
    startTime: {},
    interval: 0,
    progress: 0,
    maxDbSize: 0,
    isOffline : false
};

export default {
    namespaced: true,
    state,
    noSession,
    getters,
    actions,
    mutations
}